

module.exports = __webpack_require__.stylable.create(
    "List1584463848",
    {"classes":{"root":"List1584463848__root","header":"List1584463848__header","disclaimer":"List1584463848__disclaimer","empty":"List1584463848__empty"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "List1584463848",
    null
);
